<template>
	<div class="login">
		<div class="L-content">
			<p class="L-title">E S G 问 卷</p>
			<div class="L-form">
				<el-form ref="form" :model="form" :rules="rules" label-width="0px">
					<el-form-item label="" prop="account">
						<el-input v-model="form.account" placeholder="账号"></el-input>
					</el-form-item>
					<el-form-item label="" prop="password">
						<el-input type="password" v-model="form.password" placeholder="密码"></el-input>
					</el-form-item>
				</el-form>
				<el-button class="L-button" @click="login" type="primary">登 录</el-button>
				<el-checkbox v-model="PWDchecked">记住密码</el-checkbox>
			</div>
		</div>

	</div>
</template>

<script>
	// @ is an alias to /src
	import Cookies from 'js-cookie';
	import {
		enc,
		mode,
		AES,
		pad
	} from 'crypto-js'
	import {
		loginApi
	} from '../api/api-url/login.js'
	export default {
		name: 'Login',
		components: {

		},
		data() {
			return {
				form: {
					account: '',
					password: '',
				},
				rules: {
					account: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}, ],
				},
				PWDchecked: false
			}
		},
		mounted() {
			mode,
			pad
			let loginName = Cookies.get('loginName');
			this.form.account = loginName;
			let loginPwd = Cookies.get('loginPwd');
			if (loginPwd) {
				this.PWDchecked = true;
				let secretKey = '1203*209**hh**hh';
				let str2 = AES.decrypt(loginPwd, secretKey);
				this.form.password = str2.toString(enc.Utf8);
			} else {
				this.PWDchecked = false;
			}
		},
		methods: {
			// 登录
			async login() {
				this.$refs['form'].validate(async (valid) => {
					if (valid) {
						let res = await loginApi.questionnaireLogin({
							account: this.form.account,
							password: this.form.password,
						})
						console.log(res)
						if (res) {
							Cookies.set('loginName', this.form.account, {
								expires: 30
							})
							// 是否保存密码
							if (this.PWDchecked) {
								// 加密密钥（长度必须是 16 的整数倍，此处为 16 位）
								let secretKey = '1203*209**hh**hh';
								let str = AES.encrypt(this.form.password, secretKey);
								Cookies.set('loginPwd', str, {
									expires: 30
								})
							} else {
								Cookies.remove('loginPwd')
							}
							Cookies.set('Authorization', res.result.token, {
								expires: 1
							})
							Cookies.set('companyName', this.form.account, {
								expires: 30
							})

							// 跳转到首页
							this.$router.push({
								path: '/questionList',
							});
						}
					}
				})

			}
		}
	}
</script>

<style lang="scss">
	.login {
		width: 100%;
		height: 100%;
		position: relative;

		.L-content {
			width: 600px;
			height: 500px;
			background: url(../assets/imgs/logo-big.png) 197px 64px no-repeat;
			background-size: 207px 58px;
			background-color: #fff;
			box-shadow: 0px 2px 7px 0px rgba(208, 208, 208, 0.2);
			border-radius: 5px;
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}

		.L-title {
			margin-top: 139px;
			text-align: center;
			font-size: 22px;
		}

		.L-form {
			margin-left: 100px;
			width: 400px;
			padding-top: 24px;

			.el-input {
				input {
					height: 48px;
					margin: 5px 0;
				}
			}

			.L-button {
				width: 100%;
				line-height: 36px;
				margin-top: 20px;
				margin-bottom: 20px;
				font-size: 16px;
			}
		}
	}
</style>